import styled from 'styled-components'
import { Col, Row } from 'react-styled-flexboxgrid'
import { TextWrapper } from '../../styles/base'
import variables from '../../styles/variables'
import { Heading } from '..'
import { headerStyles } from '../../styles/global'

export const Container = styled(TextWrapper)`
  color: ${variables.colors.oracle.dark};
  margin-top: 60px !important;
  padding-bottom: 0 !important;
`
export const BlockRow = styled(Row)`
  width: 100%;
`
export const BlockCol = styled(Col)`
  display: flex !important;
  flex-direction: column;
`
export const ApiSection = styled.div`
  margin-top: 40px;
  margin-bottom: 20px;
`
export const ApiSectionCol = styled(Col)`
  display: flex;
  flex-direction: column;
  margin-top: 30px;

  &:first-child {
    display: none;
    visibility: hidden;
  }

  @media ${variables.media.sm} {
    margin-top: 0;

    &:first-child {
      display: flex;
      visibility: visible;
    }
  }
`

export const ApiSectionRow = styled(BlockRow)`
  @media ${variables.media.sm} {
    margin-top: 30px;
  }
`

export const BlockHeader = styled(Heading)`
  ${headerStyles.headerSmall};
  font-weight: normal;
`

export const BlockText = styled.div`
  max-width: 600px;
`

export const PageForDevelopers = styled.div`
  margin: 24px 0;
`
